const translation = {
  title: 'Entdecken',
  sidebar: {
    discovery: 'Entdeckung',
    chat: 'Chat',
    workspace: 'Arbeitsbereich',
    action: {
      pin: 'Anheften',
      unpin: 'Lösen',
      rename: 'Umbenennen',
      delete: 'Löschen',
    },
    delete: {
      title: 'App löschen',
      content: 'Sind Sie sicher, dass Sie diese App löschen möchten?',
    },
  },
  apps: {
    title: 'Apps von Dify erkunden',
    description: 'Nutzen Sie diese Vorlagen-Apps sofort oder passen Sie Ihre eigenen Apps basierend auf den Vorlagen an.',
    allCategories: 'Alle Kategorien',
  },
  appCard: {
    addToWorkspace: 'Zum Arbeitsbereich hinzufügen',
    customize: 'Anpassen',
  },
  appCustomize: {
    title: 'App aus {{name}} erstellen',
    subTitle: 'App-Symbol & Name',
    nameRequired: 'App-Name ist erforderlich',
  },
  category: {
    Assistant: 'Assistent',
    Writing: 'Schreiben',
    Translate: 'Übersetzen',
    Programming: 'Programmieren',
    HR: 'Personalwesen',
    Agent: 'Agent',
    Workflow: 'Arbeitsablauf',
    Entertainment: 'Unterhaltung',
  },
}

export default translation
